import $ from 'jquery';
import 'slick-carousel';

$('.shoutouts').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    fade: true,
		cssEase: 'linear',
		lazyLoad: 'ondemand'
});